import { Field } from 'formik'
import React, { useMemo } from 'react'

import { Checkbox, Fieldset, RadioButton } from '@fourthwall/components'
import { useFormikContext } from '@fourthwall/utils/dist/formik'

import { TagSelect } from '../../../../../components/TagSelect'
import { useTagsQuery } from '../../../../../hooks/useTagsQuery'
import type { FormValues } from '../../types'
import { FormFields, RssType } from '../../types'

export const RssTypeFields = () => {
  const { tagsQuery } = useTagsQuery([{ limit: 9999 }])
  const { values, setFieldValue } = useFormikContext<FormValues>()

  const handleTagAdd = (tagName: string) => {
    const tagObject = tagsQuery.data?.tags?.find((tag) => {
      return tag.name === tagName
    })

    if (tagObject) {
      setFieldValue(FormFields.rssTags, [...values.rssTags, tagObject])
    }
  }

  const handleTagRemove = (tagName: string) => {
    setFieldValue(
      FormFields.rssTags,
      values.rssTags.filter((tag) => tag.name !== tagName),
    )
  }

  const tags = useMemo(() => {
    return tagsQuery.data?.tags?.map((tag) => tag.name) || []
  }, [tagsQuery.data])

  return (
    <>
      <Fieldset.Row>
        <Field
          component={RadioButton}
          name={FormFields.rssType}
          checkedValue={RssType.all}
          label="Include all audio posts"
        />
      </Fieldset.Row>
      <Fieldset.Row>
        <Field
          component={RadioButton}
          name={FormFields.rssType}
          checkedValue={RssType.selected}
          label="Include audio posts with selected tags"
        />
      </Fieldset.Row>
      {values.rssType === 'selected' && (
        <Fieldset.Row inner>
          <Fieldset.Item>
            <TagSelect
              selectedTags={values.rssTags.map((tag) => tag.name)}
              tags={tags}
              label={tags.length === 0 ? 'You haven’t created any tags yet' : 'Select tags'}
              disabled={tags.length === 0}
              onAdd={handleTagAdd}
              onRemove={handleTagRemove}
            />
          </Fieldset.Item>
        </Fieldset.Row>
      )}
      <Fieldset.Row>
        <Field
          component={Checkbox}
          name={FormFields.hidden}
          label="Hide this perk from tiers list"
        />
      </Fieldset.Row>
    </>
  )
}
